import _objectWithoutProperties from '../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.es.js';
import _taggedTemplateLiteral from '../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, media, gridDimensions } from '@mgmresorts/wcl-styled';
import React from 'react';

var _excluded = ["children", "className"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var StyledWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  ", "\n"])), function (p) {
  return !p.overflowVisible && "overflow: hidden;";
});
var StyledContent = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex-grow: 1;\n  width: 100%;\n  ", "\n  ", "\n  ", "\n  ", "\n"])), media.sm(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "])), gridDimensions.sm.maxContainerWidth ? "max-width: ".concat(gridDimensions.sm.maxContainerWidth + 2 * gridDimensions.sm.margin, "px;") : '', gridDimensions.sm.margin, gridDimensions.sm.margin), media.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "])), gridDimensions.md.maxContainerWidth ? "max-width: ".concat(gridDimensions.md.maxContainerWidth + 2 * gridDimensions.md.margin, "px;") : '', gridDimensions.md.margin, gridDimensions.md.margin), media.lg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "])), gridDimensions.lg.maxContainerWidth ? "max-width: ".concat(gridDimensions.lg.maxContainerWidth + 2 * gridDimensions.lg.margin, "px;") : '', gridDimensions.lg.margin, gridDimensions.lg.margin), media.xl(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", "\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "])), gridDimensions.xl.maxContainerWidth ? "max-width: ".concat(gridDimensions.xl.maxContainerWidth + 2 * gridDimensions.xl.margin, "px;") : '', gridDimensions.xl.margin, gridDimensions.xl.margin));
/**
 * Wraps the children in the container with max-width and aligns them horizontally to the center.
 *
 * Use it to wrap your Modal or Page content, so it matches the width of the grid.
 *
 * Then, you can use `GridRow` and `GridColumn` components if you want to stretch your element to `n` grid columns.
 *
 * Note: Never put GridContainer in another GridContainer.
 *
 * Renders a <GridContainer /> component
 * @param {React.ReactNode} children - the children to be rendered inside the GridContainer
 * @param {string} className - set the class on the element
 **/

var GridContainer = function GridContainer(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(StyledWrapper, Object.assign({}, props, {
    "data-testid": GridContainer.selector()
  }), /*#__PURE__*/React.createElement(StyledContent, {
    className: className
  }, " ", children));
};

GridContainer.selector = function () {
  return 'GridContainer';
};

export { GridContainer };
